import { useTranslation } from "react-i18next";
import { Badge } from "~/atoms/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "~/atoms/tooltip";
import { type SharedFrom } from "~/api/types";

interface Props {
  sharedFrom: SharedFrom;
}

export const SharedFromTag = ({ sharedFrom }: Props) => {
  const { t } = useTranslation();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="info" tabIndex={0}>
            {t(($) => $.documentSharing.notice.title, {
              unit: sharedFrom.governanceUnit.name,
            })}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          {sharedFrom.status === "following"
            ? t(($) => $.documentSharing.notice.following)
            : t(($) => $.documentSharing.notice.retired)}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
